import React from "react";

export default function OrderOnline() {
	return <div>OrderOnline</div>;
}
